import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

export const StyledTypographyColorSectionNavLinkMain = styled(Typography)(
  ({ theme }) => {
    return {
      color: theme.palette.sectionNav.link.main
    };
  }
);
